import { handleResponse, buildUrl } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const resolveBookingAction = (token) =>
  fetch(buildUrl(`/api/booking-actions/resolve?token=${encodeURIComponent(token)}`), {
    credentials: "include",
  }).then(handleResponse);

export const checkoutBookingAction = (token, partnerPin) =>
  fetch(buildUrl("/api/booking-actions/checkout"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ token, partnerPin }),
    credentials: "include",
  }).then(handleResponse);

export const checkinBookingAction = (token, partnerPin) =>
  fetch(buildUrl("/api/booking-actions/checkin"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ token, partnerPin }),
    credentials: "include",
  }).then(handleResponse);

export const issueBookingActionToken = (bookingId) =>
  fetch(buildUrl(`/api/bookings/${bookingId}/action-token`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({}),
    credentials: "include",
  }).then(handleResponse);

const bookingActionsApi = {
  resolveBookingAction,
  checkoutBookingAction,
  checkinBookingAction,
  issueBookingActionToken,
};

export default bookingActionsApi;
